import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Alert,
  StatusInfo
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class UpdateExtensionMessage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal={false}>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >{this.props.success ? (
                <StatusInfo size="large" color="yellow" />
                ): (<Alert size="large" color="yellow" />)}
                <Heading size="small" level="1" margin="small">
                    Extension Update ...
                </Heading>
              </Box>
            </Box>
            <Box align="center" justify="center">
              <Heading size="small" level="4" margin="small">
               {this.props.UpdateMessage}
              </Heading>
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label="OK"
                active={false}
                primary
                reverse
                type="button"
                onClick={this.props.hide}
              />
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}

export default UpdateExtensionMessage;
